import React from 'react'
import PrivacyPolicy from '../privacy-policy'

const PrivacyPolicyPt = () => {
    return <PrivacyPolicy languageCode="pt" />
}

export default PrivacyPolicyPt
